'use strict';
var runConevrter,
catchKey,
coneverterBlur,
converterInputChange,
applyCurr,
hideOneShowOther;
var lgToMdTransform;
var $window = jQuery(window),
    winWidth = $window.outerWidth(), //with scrollbar
    winHeight = $window.height(),
    $document = jQuery(document),
    cssBreakPoints = {
	    'xs': 480,
	    'sm': 768,
	    'md': 992,
	    'lg': 1250
    },
    $body = jQuery('body'),
    $html = jQuery('html'),
    $htmlBody = $html.add($body),
    $mainNavBlock = $('#main-nav-block'),
	$functionLoadChat = null,
    transitionDuration = 200,
    maxHeightForSlideUpDown = 800,
    globalLang = globalLang || 'en',
    rtlLangs = ['ar', 'fa'],
	rtl = (rtlLangs.indexOf(globalLang) == -1) ? false : true,//mainly for sliders
	jscd = new Jscd(),
	$_GET = {},
	locationHash = window.location.hash;


var chatloaded = false;

function moveDSCtoLeft(){
	if(globalLang === 'ar'){
		setTimeout(()=>{
			let sch1 = document.querySelector('.bojiJp');
			if(sch1 !== null) {
				sch1.style.left="10px";
				sch1.style.right="auto";
			}
		},500);
	}
}

var onDCCReady = function(){

	$('#dc-support-chat-btn').addClass('chat-opened').fadeOut(.2);
	DCC_loadChat();
	chatloaded = true;
	moveDSCtoLeft();

}


function onDCC_ChatClosed(){

	$('#dc-support-chat-btn').removeClass('chat-opened').removeClass('loading').fadeIn(.2);

	$('#dc-support-chat-btn').on('click',()=>{
		$('#dc-support-chat-btn').fadeOut(.2);
			DCC_openChat();
			moveDSCtoLeft();
	});

}

// if (typeof sectionId === undefined) {//for pages with different from site templates (e.g. /downloads/), where this variable
// 	var sectionId;
// }

jQuery.fn.extend({
	slideDownFadeIn: function(dur, callback) {
		var self = this;
		self.addClass('slideDownFadeIn');

		self.slideDown(dur, function() {
			self.addClass('shown');
			setTimeout(function() {
				self.removeClass('slideDownFadeIn shown');
				if (callback) {
					callback.call(self);
				}
			}, dur);
		});
		
		return self;
	},
	fadeOutSlideUp: function(dur, callback) {
		var self = this;
		self.addClass('shown fadeOutSlideUp');
		self.removeClass('shown');
		setTimeout(function() {
			self.slideUp(dur, function() {
				self.removeClass('fadeOutSlideUp');
				if (callback) {
					callback.call(self);
				}
			});
		}, dur);
		// setTimeout(function() {
			
		// }, dur*2);
		return self;
	// },
	// makeTabs: function() {
	// 	var self = this;

	// 	this.each(function() {
	// 		var $tab = $(this),
	// 		    $tabContent = ($tab.data('tabs-content')) ? $('#' + $tab.data('tabs-content')) : $tab.next();

	// 		$tab.find('a').on('keypress click', function(e) {

	// 			if (e.which === 13 || e.type === 'click') {
	// 				e.preventDefault();
	// 				var $this = $(this);

	// 				if (!$(this).hasClass('active')) {
	// 					var activeTab = $tabContent.children('.active');
	// 					hideOneShowOther(activeTab, $tabContent.find($this.attr('href')), function() {
	// 						$tab.find('.active').removeClass('active');
	// 						$this.addClass('active');
	// 						$tab.trigger('dc.tabSwitched');
	// 					});

	// 					if ($this.data('hash')) {
	// 						if (history.replaceState) {
	// 							history.replaceState('', '', $this.data('hash'));
	// 						} else {
	// 							window.location.hash = $this.data('hash');
	// 						}
	// 					}
	// 				}
	// 			}
	// 		});
	// 	});

	// 	return this;
	}
});



(function($) {
	var htmlBody = $('html, body'),
	    //function initializes parallaxed blocks (e.g. on Login page)
		initParallaxedBlock = function($parallaxedBlock, $loginTabs) {

			if (!$parallaxedBlock.hasClass('initialized')) {
				var mobile = jscd.checkMob(),
				    parallaxedBlockOuterHeight,
				    parallaxStart,
				    parallaxEnd,
					winScroll,
					translateY;

				calculateMetrics();

				$window.on('scroll.block-parallax', function() {
					proceedParallaxedBlock();
				});

				$window.on('custom.onresize', function() {
					calculateMetrics();
				});

				$parallaxedBlock.addClass('initialized');
				proceedParallaxedBlock();

				if ($loginTabs && $loginTabs.length) {
					$loginTabs.on('dc.tabSwitched', function(e, $tab, $tabsContent) {//for recalculating in not active tab after resize
						$tabsContent.find('.parallaxed-block').each(function() {
							calculateMetrics();
							proceedParallaxedBlock();
						});
					});
				}

				function calculateMetrics() {
					var mainNavBlockOuterHeight;
					parallaxedBlockOuterHeight = $parallaxedBlock.outerHeight();
					winHeight = $window.height();

					if ($mainNavBlock.length) {//login
						mainNavBlockOuterHeight = $mainNavBlock.outerHeight();
					} else {//downloads pages
						mainNavBlockOuterHeight = 0;
					}

					// if (parallaxedBlockOuterHeight > winHeight) {
					// 	parallaxStart = $parallaxedBlock.offset().top + parallaxedBlockOuterHeight - winHeight;
					// 	parallaxEnd = parallaxStart + winHeight;
					// } else {
					// 	parallaxStart = $parallaxedBlock.offset().top  - mainNavBlockOuterHeight - 30;
					// 	parallaxEnd = parallaxStart + parallaxedBlockOuterHeight;
					// }
					parallaxStart = $parallaxedBlock.offset().top  - mainNavBlockOuterHeight - 30;
					parallaxEnd = parallaxStart + parallaxedBlockOuterHeight;

				}

				function proceedParallaxedBlock() {
					winScroll = $window.scrollTop();
					translateY = (winScroll - parallaxStart)/(parallaxEnd - parallaxStart) * parallaxedBlockOuterHeight/2;

					if (winScroll >= parallaxStart && winScroll < parallaxEnd) {

						if ($parallaxedBlock.hasClass('parallax-top')) {
							$parallaxedBlock.removeClass('parallax-top');//To fit bckg-image to top (not e.g. 0.746494px)
						}

						// if (mobile) {
						// 	$parallaxedBlock.css({
						// 		'opacity': 1 - (winScroll - parallaxStart)/(parallaxEnd - parallaxStart);
						// 	});
						// } else {
						// 	$parallaxedBlock.css({
						// 		'-webkit-transform': 'translate(0,' + translateY + 'px)',
						// 		'-ms-transform': 'translate(0,' + translateY + 'px)',
						// 		'-o-transform': 'translate(0,' + translateY + 'px)',
						// 		'transform': 'translate(0,' + translateY + 'px)',
						// 		'opacity': 1 - (winScroll - parallaxStart)/(parallaxEnd - parallaxStart)
						// 	});
						// }
						$parallaxedBlock.css({
							'-webkit-transform': 'translate(0,' + translateY + 'px)',
							'-ms-transform': 'translate(0,' + translateY + 'px)',
							'-o-transform': 'translate(0,' + translateY + 'px)',
							'transform': 'translate(0,' + translateY + 'px)',
							'opacity': 1 - (winScroll - parallaxStart)/(parallaxEnd - parallaxStart)
						});
					} else if (winScroll < parallaxStart) {

						if (!$parallaxedBlock.hasClass('parallax-top')) {
							$parallaxedBlock.addClass('parallax-top');
						}
					}
				}
			}
		};
	
	$(function() {
		hideOneShowOther = function(willBeHidden, willBeShown, callback) {
			var willBeShownBlockHeight = willBeShown.css({'visibility':'hidden', 'display':'block'}).height();
			willBeShown.css({'display':'none', 'visibility':'visible'});
			// var willBeShownBlockHeight = willBeShown.height();
			var willBeHiddenBlockHeight = willBeHidden.height() || 0,
			    minHeightedBlock = willBeShown.parent();

			if (willBeShownBlockHeight > willBeHiddenBlockHeight) {
				// console.log('>',willBeShownBlockHeight)
				minHeightedBlock.css('min-height', minHeightedBlock.outerHeight());
				willBeHidden.fadeOut(transitionDuration, function() {
					willBeHidden.removeClass('active');
					willBeShown.addClass('slideDownFadeIn active').slideDownFadeIn(transitionDuration, function() {
						// willBeShown.addClass('shown');
						setTimeout(function() {
							willBeShown.removeClass('slideDownFadeIn shown');
							minHeightedBlock.css('min-height', 'auto');//in case of wrong calculations
						}, transitionDuration);

						if (callback) {
							callback();
						}
					});
				});
			} else if (willBeShownBlockHeight < willBeHiddenBlockHeight) {
				// console.log('<',willBeShownBlockHeight)
				minHeightedBlock.css('min-height', minHeightedBlock.outerHeight() - minHeightedBlock.height() + willBeShownBlockHeight);
				willBeHidden.addClass('slideDownFadeIn shown').fadeOutSlideUp(transitionDuration, function() {
					willBeHidden.removeClass('active slideDownFadeIn');
					willBeShown.fadeTo(transitionDuration, 1, function() {//fadeTo instead of fadeIn, because of Safary's blinking =/
						willBeShown.addClass('active').css('opacity', '');//opacity, '' - because of fadeTo
						minHeightedBlock.css('min-height', 'auto');//in case of wrong calculations

						if (callback) {
							callback();
						}
					});
				});
			} else {
				// console.log('=')
				minHeightedBlock.css('min-height', minHeightedBlock.outerHeight());
				willBeHidden.fadeOut(transitionDuration, function() {
					willBeHidden.removeClass('active');
					willBeShown.fadeTo(transitionDuration, 1, function() {//fadeTo instead of fadeIn, because of Safary's blinking =/
						// willBeShown.addClass('shown');
						willBeShown.addClass('active').css('opacity', '');//opacity, '' - because of fadeTo
						// willBeShown.removeClass('slideDownFadeIn shown');
						if (callback) {
							callback();
						}
					});
				});
			}
			
			// minHeightedBlock.css('min-height', minHeightedBlock.outerHeight() - minHeightedBlock.height() + willBeShownBlockHeight);
			// willBeHidden.fadeOutSlideUp(transitionDuration, function() {
			// 	willBeShown.fadeIn(transitionDuration, function() {
			// 		if (callback) {
			// 			callback();
			// 		}
			// 	});
			// });
		}

		var $textareas = $('.material textarea').on('input', function() {
			syncTextareaWithDiv($(this));
		});

		$textareas.each(function() {//for the case of refreshing the page in FF
			syncTextareaWithDiv($(this));
		});

		function syncTextareaWithDiv($textarea) {
			$textarea.prev().html($textarea.val().replace(/\r?\n$/g, '<br><br>').replace(/\r?\n/g, '<br>'));
		}

		var unfoldingTriggerCallBacks = {
			'tp-videos': function($trigger, $parent, $block) {

				if ($parent.hasClass('opened')) {
					$block.find('video').each(function() {
						this.pause();
					});
					$block.find('.child-item').removeClass('active');
				} else {
					$block.find('video').each(function() {
						this.play();
					});
					$block.find('.child-item').addClass('active');
				}

			}
		}

		$('.unfolding-trigger').on('keypress click',function(e) {

			if (e.which === 13 || e.type === 'click') {
				e.preventDefault();
				var $this = $(this),
				    parent = $this.parent(),
					next = ($this.data('unfolding-block-id')) ? $('#' + $this.data('unfolding-block-id')) : $this.next();
					
				if (parent.hasClass('opened')) {
					
					if ($this.hasClass('beauty')) {
						next.fadeOutSlideUp(transitionDuration);
					} else {
						next.css('display', 'block').slideUp((next.height() > maxHeightForSlideUpDown) ? transitionDuration*2 : transitionDuration, function() {
							fixQuickDemo();
						}); //css('display', 'block') is needed for hiding opened after page loading submenu
					}

				} else {
					
					if ($this.hasClass('beauty')) {
						next.slideDownFadeIn(transitionDuration);
					} else {
						next.slideDown((next.height() > maxHeightForSlideUpDown) ? transitionDuration*2 : transitionDuration, function() {
							fixQuickDemo();
						});
					}

				}

				var callback = $this.data('callback');

				if (callback) {
					unfoldingTriggerCallBacks[callback]($this, parent, next);
				}

				document.activeElement.blur();//Not to stay focus styled
				parent.toggleClass('opened');
			}
		});

		//Tabs
		var $tabs = $('.dc-tabs');
		$tabs.each(function() {
			var $tab = $(this),
			    tabContentId,
			    $tabsContent = (tabContentId = $tab.data('tabs-content')) ? $('#' + tabContentId) : $tab.next();

			$tab.find('a').on('keypress click', function(e) {
				if (e.which === 13 || e.type === 'click') {
					e.preventDefault();
					var $this = $(this);

					if (!$this.hasClass('active')) {
						var $activeTab = $tabsContent.children('.active'),
						    $openingTab = $tabsContent.find($this.attr('href'));
						hideOneShowOther($activeTab, $openingTab, function() {
							$tab.find('.active').removeClass('active');
							$this.addClass('active');
							$tabsContent.removeClass($activeTab[0].id + '-active').addClass($openingTab[0].id + '-active');//Need for Reports block on MT4 tab on Login page
							$tab.trigger('dc.tabSwitched', [$this, $openingTab]);
						});

						if ($this.data('hash')) {
							if (history.replaceState) {
								history.replaceState('', '', $this.data('hash'));
							} else {
								window.location.hash = $this.data('hash');
							}
						}
					}
				}
			});
		});

		var $loginTabs = $tabs.filter('#login-tabs');

		if ($loginTabs.length) {
			$loginTabs.on('dc.tabSwitched', function(e, $tab, $tabsContent) {
				$tabsContent.find('.parallaxed-block').each(function() {
					initParallaxedBlock($(this), $loginTabs);
				});
			});
		}
		
		var $loginTabsBlock = $('#login-tabs-block');
		
		if (locationHash) {
			var $locationHash = $(locationHash);

			if ($locationHash.length) {
				var locationHashTabId = $locationHash.data('tab-id');

				if (locationHashTabId) {
					var $tab = $('#' + locationHashTabId);

					if ($tab.length) {
						$tab.click();
					}

				} else {
					var locationHashPar = $locationHash.parent();

					if (locationHashPar.hasClass('unfolding-trigger')) {

						 let curElement = locationHashPar.parent();
						 let parentFold = false;

						 while(curElement && !curElement.hasClass('main-container')) {
						 	curElement = curElement.parent();

						 	if(curElement.prop("tagName") == 'LI' && curElement.hasClass('unfolding-item')) {
						 		parentFold = curElement.children().first();
						 	}
						 }

						if( parentFold ) {
							parentFold.click();
						}
						locationHashPar.click();

					}
				}

			}
		} else {
			
			if ($loginTabsBlock.length && jscd.checkMob()) {
				$loginTabsBlock.find('#jf-mobile').click();
			}

		}

		// var locationSearch = window.location.search;
		// if (locationSearch) {
		// 	var $locationSearch = $(locationSearch.replace('?', '#'));

		// 	if ($locationSearch.length) {

		// 		if ($locationSearch.hasClass('tab')) {
		// 			$locationSearch.click();
		// 		}
		// 	}
		// }
		$('.inner-link').click(function(e) {
			e.preventDefault();
			var $this = $(this),
			    goal = $this.attr('href');
			htmlBody.animate({scrollTop: $(goal).offset().top}, '200');
			document.activeElement.blur();//Not to stay focus styled
			window.location.hash = goal;
		});
		//Buttons, which call popups
		$('.show-popup-btn').click(function(e) {
			e.preventDefault();
			var $msg = $('#' + $(this).data('msg-id'));
			showDialog($msg, $(this).data('msg-id'), $(this));
		});
		$('.send-us-message').click(function() {
			var $msg = $('#' + $(this).data('msg-id'));
			showDialog($msg, $(this).data('msg-id'), $(this), function() {
				$msg.find('#cb-firstName').focus();
			});
		});
		// setTimeout(function(){
		// 	$('.send-us-message').click();
		// },1000)
		//For inputs with animated label
		$('.with-label').each(function() { //In case some info after refresh
			var $this = $(this);

			if ($this.val()) {
				$this.parent().addClass('entered');
			}

		});

		$('.with-label').on('change', function() {
			var $this = $(this);

			if ($this.val()) {
				$this.parent().addClass('entered');
			} else {
				$this.parent().removeClass('entered');
			}

		});

		$('.input-arrows').each(function(i,k) {
			var $this = $(this),
			    $inputArrow = $this.find('.input-arrow'),
				// $arrowTop = $this.find('.arrow-top'),
				// $arrowBottom = $this.find('.arrow-bottom'),
				$input = $('#' + $this.data('input-id')),
				min,
				max,
				step;

			updateValues();

			$inputArrow.on('click', function() {
				var $this = $(this);

				if ($this.hasClass('arrow-top')) {
					increaseVal();
				} else {
					decreaseVal();
				}
				
				$input.trigger('change');
			});

			$input
				.on('keydown', function(e) {
					
					if (e.which == 38) {
						e.preventDefault();
						increaseVal();
					} else if (e.which == 40) {
						e.preventDefault();
						decreaseVal();
					}

				})
				.on('blur', function() {
					var curValNumber = getCurrentNumber($input);
					
					if (!curValNumber) {//abc => 1000
						$input.val(min);
						$input.trigger('change');
					} else if (curValNumber != $input.val()) {//123abc => 123
						$input.val(curValNumber);
						$input.trigger('change');
					}

				});

			// $arrowBottom.on('click', function() {
			// 	var curValNumber = getCurrentNumber($input);
			// 	$input.val(curValNumber - step);
			// 	$input.trigger('change');
			// });
			function updateValues() {
				min = parseFloat($input.attr('min')) || 0,
				max = parseFloat($input.attr('max')) || Infinity,
				step = parseFloat($input.data('step'))
			}

			function increaseVal() {
				updateValues();
				var curValNumber = getCurrentNumber($input),
				    newValNumber = curValNumber + step;
				$input.val((newValNumber < max) ? newValNumber : max);
			}

			function decreaseVal() {
				updateValues();
				var curValNumber = getCurrentNumber($input),
				    newValNumber = curValNumber - step;
				$input.val((newValNumber > min) ? newValNumber : min);
			}
			
			function getCurrentNumber($input) {
				var curVal = $input.val();
				return (curVal) ? parseFloat(curVal) : 0;
			}
		});

		var dopBlock = $('.depends-on-platform');
		if (dopBlock.length) {
			var mobile = jscd.checkMob();

			if (mobile) {
				dopBlock.addClass('mobile');
				var os = jscd.getOs();

				if (os == 'iOS') {
					dopBlock.addClass('ios');
				} else if (os == 'Android') {
					dopBlock.addClass('android');
				}
			}
		}

		//Custom scrollbars
		// $(".custom-scroll").mCustomScrollbar({
		// 	axis: 'y',
		// 	scrollbarPosition: 'outside',
		// 	autoHideScrollbar: true,
		// 	callbacks: {
		// 		onTotalScroll: function() {
		// 			$(this).addClass('scroll-finish');
		// 		},
		// 		onScrollStart: function() {
		// 			var $this = $(this);
		// 			if ($this.hasClass('scroll-finish')) {
		// 				$this.removeClass('scroll-finish');
		// 			}
		// 		}
		// 	}
		// });
		

		var osLinksBlock = $('.link-depends-on-ios');

		if (osLinksBlock.length) {
			var os = jscd.getOs(),
			    osBits = jscd.getBits(),
			    correctDefLink = osLinksBlock.find('.' + os.toLowerCase() + '-' + osBits),
			    defLink = osLinksBlock.find('.def-link');

			    if (correctDefLink.length) {
					defLink.text(correctDefLink.text()).attr('href', correctDefLink.attr('href'));
					correctDefLink.remove();
				}
		}
		var osLinksBlock2 = $('.link-depends-on-ios2');

		if (osLinksBlock2.length) {
			var correctDefLink2 = osLinksBlock2.find('.' + os.toLowerCase() + '-' + osBits),
				defLink2 = osLinksBlock2.find('.def-link');

			if (correctDefLink2.length) {
				defLink2.text(correctDefLink2.text()).attr('href', correctDefLink2.attr('href'));
				correctDefLink2.remove();
			}
		}

		//$loginContent.find('.tab-content').not('.active').hide();//for sliders correct initialization
		
		// $('.tabs').find('a').on('keypress click', function(e) {
		// 	if (e.which === 13 || e.type === 'click') {
		// 		e.preventDefault();
		// 		var $this = $(this);

		// 		console.log('ohoho')
		// 	}
		// });

		

		if ($body.hasClass('downloads')) {
			var hash = location.hash;
			
			if (hash) {
				var button = $(hash + '-download');

				if (button.length) {
					button.get(0).click();
				}

			}

		}

		var $dcChatBtn = $('#dc-support-chat-btn').on('click', function() {
			var $this = $(this);
			$this.addClass('loading');
			loadSupportChat();
			$this.off('click');

		});

		if (getCookie('dcChatActive')) {
			$dcChatBtn.click();
		}

		$('.invoke-chat').on('click', function() {
			
			if (!$dcChatBtn.hasClass('chat-opened')) {
				$dcChatBtn.click();
			} else {
				document.dcc_showSupportChat();//if it's collapsed
			}

		});

		function loadSupportChat_old() {
			var chatScript = document.createElement('script');

			chatScript.src = 'https://support.dukascopy.com/loader.js';
			$(chatScript).attr({
				'supportChatDelay': '0',
				'supportChatCollapsed': 'false',
				'supportIgnoreClose': 'true',
				'async': 'true',
				'view': 'false',
				'data': 'D7WBWOWdDAWRW3WBDQWlDQDAWhDADQDTDpIYDzWvDXWcDADNIEIuIcWiDCWTDWWSWKWDDLDYW6WKWdWiIcWRIEWhWdD8IEWfIEWlDWWEIcDf',
				'supportChatEp': '139'
			})
			var waitChat = window.setInterval(function() { //Т. к. нет нормального коллбэка
				//console.log('waitChat');
				if ($('.dccContainerChat').html()) {
					clearInterval(waitChat);
					$dcChatBtn.addClass('chat-opened');
					document.dcc_openSupportChat();
					setCookie('dcChatActive', '1', {
						expires: 3600,
						path: '/'
					});
				}
				
			}, 100);
			$body.append(chatScript);
		}


		function loadSupportChat(){

			if(chatloaded === false) {
				let scrpt = document.createElement('script');
				scrpt.setAttribute('src','https://support.dukascopy.com/widget/dccloader.js');
				scrpt.setAttribute('payer-auth-token',"");
				scrpt.setAttribute('entry-point-id', "139"); // 30 - swiss	// 56 - europe	// 76 - japan
				scrpt.setAttribute('right-offset', "30");
				scrpt.setAttribute('bottom-offset', "30");
				scrpt.setAttribute('title', "Chat with us");
				scrpt.setAttribute('prompt-message', "Type your message");
				scrpt.setAttribute('remove-start-button',"true");
				document.body.appendChild(scrpt);
				chatloaded = true;
			}
			else{
				DCC_openChat();
			}
		}


		$functionLoadChat = loadSupportChat;

		// $('.show-tooltip').on('click', function() {//For iOS
		// 	var parent = $(this).parent('.with-tooltip');

		// 	if (parent.hasClass('active')) {
		// 		parent.removeClass('active').addClass('not-active');
		// 		document.activeElement.blur();//Not to stay focus styled
		// 	} else {
		// 		parent.removeClass('not-active').addClass('active');
		// 	}
		// });
		

		$body.on('touchstart', function() {});//For closing e.g. tooltips in iOS
		
	});
	//Check the support of CSS property
	function SupportsCSS(property, value) {
		try {
			var element = document.createElement('span');
			if (element.style[property] !== undefined) {
				element.style[property] = value;
			} else {
				return false;
			}
			return element.style[property] === value;
		} catch (e) {
			return false;
		}
	}

	//to have access to all get parameters. https://stackoverflow.com/questions/1586330/access-get-directly-from-javascript
	var parts = window.location.search.substr(1).split("&");

	for (var i = 0; i < parts.length; i++) {
		var temp = parts[i].split("=");
		$_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
	}

	$window.on('load', function() {

		if ($_GET.autoClick) {//on /downloads/ pages
			var clickObj = $('#' + $_GET.autoClick);
	
			if (clickObj.length) {
				clickObj.get(0).click();
			}
	
		}

		//Big banner on main page animation
		var bigBanner = $('#big-banner');

		if (bigBanner.length) {
			if (SupportsCSS('clipPath', 'polygon(0% 100%)') || SupportsCSS('webkitClipPath', 'polygon(0% 100%)')) {
				if (winHeight + $window.scrollTop() > bigBanner.offset().top + bigBanner.height()) {
					bigBanner.addClass('animated');
				} else {
					$window.on('scroll.big.banner', function() {
						if (winHeight + $window.scrollTop() > bigBanner.offset().top + bigBanner.height()) {
							bigBanner.addClass('animated');
							$window.off('scroll.big.banner');
						}
					});
				}
			}
		}

		//Internal pages parallax
		var noParallaxPages = [15647, 15525, 5381, 5319, 5540];

		if ($mainTopBlock.length && !(noParallaxPages.indexOf(sectionId) > -1)) {
			var mainNavBlockHeight = $mainNavBlock.outerHeight(),
				mainTopBlockHeight = $mainTopBlock.outerHeight(),
				h1 = $mainTopBlock.find('h1'),
				parallaxStart = $mainTopBlock.offset().top - mainNavBlockHeight,
				parallaxEnd = parallaxStart + mainTopBlockHeight;
			$window.on('scroll', function() {
				var winScroll = $window.scrollTop();

				if (winScroll > parallaxStart && winScroll < parallaxEnd) {

					if ($mainTopBlock.hasClass('no-parallax-top')) {
						$mainTopBlock.removeClass('no-parallax-top');//To fit bckg-image to top (not e.g. 0.746494px)
					}
					$mainTopBlock.css({
						//'transform': 'translate3D(0,' + (winScroll - parallaxStart)/2 + 'px,0)',
						'background-position' : '50% -' + (winScroll - parallaxStart)*(500 - mainTopBlockHeight)/mainTopBlockHeight + 'px'
					});
					h1.css({
						'-webkit-transform': 'translate3D(0,' + (winScroll - parallaxStart)/4 + 'px,0)',
						'-ms-transform': 'translate3D(0,' + (winScroll - parallaxStart)/4 + 'px,0)',
						'-o-transform': 'translate3D(0,' + (winScroll - parallaxStart)/4 + 'px,0)',
						'transform': 'translate3D(0,' + (winScroll - parallaxStart)/4 + 'px,0)'
					});
				} else if (winScroll <= parallaxStart) {

					if (!$mainTopBlock.hasClass('no-parallax-top')) {
						$mainTopBlock.addClass('no-parallax-top');
					}
				}
			});
		}

		$(".custom-scroll-y").customScroll({
			rtl: rtl,
			axis: 'y'
		});

		$(".custom-scroll-x").customScroll({
			rtl: rtl,
			axis: 'x'
		});

		fixQuickDemo();

		//Offices parallax
		var parallaxBlock = $('.parallax-block');
		parallaxBlock.each(function() {
			var item = $(this),
			    parallaxBlockHeight = item.outerHeight(),
			    parallaxStart = item.offset().top - winHeight,
			    parallaxEnd = parallaxStart + winHeight + parallaxBlockHeight;
			//proceedParallax(item);
			$window.on('scroll.offices', function() {
				proceedParallax(item, parallaxBlockHeight, parallaxStart, parallaxEnd);
			});
		});

		function proceedParallax(item, parallaxBlockHeight, parallaxStart, parallaxEnd) {
			var winScroll = $window.scrollTop();

			if (winScroll > parallaxStart && winScroll < parallaxEnd) {

				if (item.hasClass('no-parallax-top')) {
					item.removeClass('no-parallax-top');//To fit bckg-image to top (not e.g. 0.746494px)
				}

				item.css({
					'background-position' : '50% ' + (winScroll - parallaxStart)/(parallaxEnd - parallaxStart)*100 + '%'
				});
			} else if (winScroll <= parallaxStart) {

				if (!item.hasClass('no-parallax-top')) {
					item.addClass('no-parallax-top');
				}
			} else {
				//console.log('finish');
			}
		}

		//Image comparison (Login page)
		var $loginContent = $('.section-5381, .section-5540');
		//$loginContent.find('.tab-content').not('.active').show();//for sliders correct initialization
		$('.login-ba-slider').beforeAfter({
			defaultPos: 80,
			leftToRightCallback: function() {
				$loginContent.removeClass('dark-theme');
			},
			rightToLeftCallback: function() {
				$loginContent.addClass('dark-theme');
			},
			synchronized: true,
			init: function() {
				this.parents('.login-platform').addClass('slider-initialized');
			},
			initAnimFinished: function() {
				// this.parents('.login-platform').addClass('slider-initialized-and-animated');
			}
		});

		var $parallaxedBlocks = $('.parallaxed-block');

		if ($parallaxedBlocks.length) {
			$parallaxedBlocks.each(function() {
				var $parallaxedBlock = $(this);

				if ($parallaxedBlock.is(':visible')) {
					initParallaxedBlock($parallaxedBlock);
				}
			});
		}

		// //Info about nearest webinar in rich menu
		// //$.get('https://dukadeploy.php-test.site.dukascopy.com/plugins/seminar/webinars_json.php?lang=en&length=1', function(res) {
		// $.get('https://www.dukascopy.com/plugins/seminar/webinars_json.php?lang=en&length=1', function(res) {
		// 	if (res.code == 0) {
		// 		var data = res.data,
		// 		    date = new Date(data[0].unix_date*1000),
		// 		    days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		// 		    monthes = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
		// 		    bannerTv = $('#banner-tv');
		// 		bannerTv.find('.date').text(days[date.getDay()] + ', ' + monthes[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getHours() + ':' + ((date.getMinutes()) ? date.getMinutes() : '00'));
		// 		bannerTv.find('.description').text(data[0].topic);
		// 	}
		// });

		function scaleBlock(block, parent) {
			var blockW = block.width(),
			    blockH = block.height(),
			    parentW = parent.width();
			if (blockW > parentW) {
				var koef = parentW/blockW;
				block.css({
					'-webkit-transform': 'scale(' + koef + ')',
					'-ms-transform': 'scale(' + koef + ')',
					'-o-transform': 'scale(' + koef + ')',
					'transform': 'scale(' + koef + ')'
				});
				parent.height(blockH*koef);
			} else {
				block.css({
					'-webkit-transform': 'none',
					'-ms-transform': 'none',
					'-o-transform': 'none',
					'transform': 'none'
				});
				parent.height('auto');
			}
		}
		var scalableBlock = $('.scalable-block');

		if (scalableBlock.length) {
			scaleBlock(scalableBlock, scalableBlock.parents('.scalable-block-parent'));
		}

		$window.on('custom.onresize', function(e, changed) { //triggered in blocks-movement.js because of bug in system resize event on iPad
			// console.log(changed)
			if (stickyBtnsBlock.length) {
				$window.off('scroll.sticky-banking-btns');
				makeBankingBeautyBtns();
			}

			if (scalableBlock.length) {
				scaleBlock(scalableBlock, scalableBlock.parents('.scalable-block-parent'));//LP PAMM
			}

			if ($fixedLeftColBlock.length) {
				fixQuickDemo();
			}
		});

		$('video').each(function() {
			var $this = $(this),
				src = $this.data('src');
			
			if (src) {

				if (window.devicePixelRatio > 1) {
					src += '@2x';
				}

			}
			
		});
		
		$('.video-features-block .child-item').on({
			'mouseenter.tp-video-features': function() {
				// var $this = $(this),
				//     $video = $this.find('video');
				// $video.get(0).play();
				proceedVideoFeatures.call(this);
			},
			'mouseleave.tp-video-features': function() {
				// var $this = $(this),
				//     $video = $this.find('video');
				// $video.get(0).pause();
				proceedVideoFeatures.call(this);
			},
			'touchend.tp-video-features': function() {
				proceedVideoFeatures.call(this);
			}
		});

		function proceedVideoFeatures() {

			if (winWidth >= cssBreakPoints['md']) {//on tablets and mobiles works by other logic
				var $this = $(this),
					$parent = $this.parents('.video-features-block'),
					$active = $parent.find('.active'),
					$activeVideo = $active.find('video'),
					$video = $this.find('video');

				$active.removeClass('active');
				$activeVideo.each(function() {//each - for both themes videos
					this.pause();
				});
				
				if ($this.hasClass('active')) {
					$video.each(function() {//each - for both themes videos
						this.pause();
					});
					$this.removeClass('active');
				} else {
					$this.addClass('active');
					$video.each(function() {//each - for both themes videos
						this.play();
					});
				}
			}

		}
	});

	var $mainTopBlock = $('#main-top-block'),
	    $sidebarCol = $('#sidebar-col'),
	    $mainCenterCol = $('#main-center-col'),
		$fixedLeftColBlock = $('.fixed-left-col-block');
		
	function fixQuickDemo() {
		//For fixing quick demo on scroll
		if ($mainTopBlock.length && $sidebarCol.length && $sidebarCol.is(':visible')) {
			var newSidebarColHeight = $mainTopBlock.height() + $mainCenterCol.height();
			$sidebarCol.css('min-height', newSidebarColHeight);
			// if (sidebarCol.height() < newSidebarColHeight) {
			// 	sidebarCol.css('min-height', newSidebarColHeight);
			// }
		}
	}

})(jQuery)